import './Carousel.css';

const Carousel = () => {
  return (
      <div className='hero container'>
        <div className='pic' id='pic3' />
        <div className='pic' id='pic2' />
        <div className='pic' id='pic1' />
      </div>
  );
};

export default Carousel
